var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMainMenuSettings = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9585 2.59893H12.9586C13.6463 2.82816 14.1101 3.47182 14.1099 4.19672V4.24233C14.1097 5.15823 14.8416 5.90634 15.7573 5.92614L15.8558 5.92827C16.4803 5.94177 17.046 6.29993 17.3254 6.85866V6.85866C17.6495 7.50704 17.5224 8.29014 17.0096 8.80258L16.9774 8.8348C16.3296 9.48227 16.3181 10.5288 16.9516 11.1903L17.0197 11.2614C17.4518 11.7126 17.5986 12.3658 17.401 12.9584V12.9584C17.1718 13.6462 16.5281 14.11 15.8032 14.1098H15.7577C14.8417 14.1095 14.0936 14.8414 14.0738 15.7571L14.0717 15.8556C14.0582 16.4801 13.7001 17.0459 13.1413 17.3252V17.3252C12.4929 17.6494 11.7098 17.5222 11.1974 17.0095L11.1652 16.9772C10.5177 16.3294 9.47116 16.318 8.80967 16.9515L8.73855 17.0196C8.28741 17.4516 7.63414 17.5984 7.04153 17.4009V17.4009C6.35382 17.1717 5.89002 16.528 5.89022 15.8031V15.7575C5.89047 14.8416 5.15856 14.0935 4.24287 14.0737L4.14437 14.0716C3.51985 14.0581 2.95412 13.6999 2.67477 13.1412V13.1412C2.35058 12.4928 2.47773 11.7098 2.99041 11.1973L3.02267 11.1651C3.67048 10.5176 3.68195 9.47107 3.04847 8.80957L2.98031 8.73839C2.54826 8.28724 2.40148 7.63398 2.59901 7.04138V7.04138C2.82825 6.35366 3.47191 5.88987 4.19682 5.89006H4.2424C5.1583 5.89031 5.90641 5.1584 5.92621 4.24271L5.92834 4.14422C5.94184 3.51971 6.29998 2.95399 6.85869 2.67463V2.67463C7.50707 2.35044 8.29016 2.47763 8.80261 2.99036L8.83481 3.02258C9.48228 3.67042 10.5289 3.68187 11.1903 3.04835L11.2614 2.98026C11.7126 2.54816 12.3659 2.40137 12.9585 2.59893Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.99997,
    cy: 9.99997,
    r: 2.0842,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMainMenuSettings);
export default ForwardRef;